import { withStyles } from '@mui/styles';
import Button from './button';
import { styles } from './button.styles';

export default withStyles(styles, { withTheme: true })(Button);
